import { render, staticRenderFns } from "./slo.vue?vue&type=template&id=20461937&scoped=true"
import script from "./slo.vue?vue&type=script&lang=js"
export * from "./slo.vue?vue&type=script&lang=js"
import style0 from "./slo.vue?vue&type=style&index=0&id=20461937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20461937",
  null
  
)

export default component.exports